import { useQuery } from "@tanstack/react-query"

import { getCitaPendiente } from "../services/cita.service";

export const useCitaPendiente = (id) => {

    const citaPendienteQuery = useQuery({
        queryKey: ['citaPendiente'],
        queryFn: () => getCitaPendiente(id),
        staleTime: 0, // nulo
    });

    return {
        citaPendienteQuery,
    }
}